/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

class ClassAttributor {
  constructor(_attr?: any, _key?: any, _cfg?: any) {}
}
class StyleAttributor {
  constructor(_attr?: any, _key?: any, _cfg?: any) {}
}
class Attributor {}

const Parchment: any = {
  Scope: { INLINE: 1, BLOCK: 2 },
  ClassAttributor,
  StyleAttributor,
  Attributor,
};

const Quill: any = {
  import: (_path: string) => ({ whitelist: [], add: () => {} }),
  register: (_any: any, _b?: any) => {},
};

export default Quill;
export { Parchment };
